<template>
  <div class="login">
    <div class="login">
      <video :src="demoVideo" autoplay muted playsinline></video>
      <img alt="" @click="openPopup" src="@/assets/images/bq.png" class="lang-icon"
        style="width: 24px; height: 24px; border-radius: 100%;">
      <div class="login-container">
        <div class="title">
          <!-- <div class="title-box">{{ t('register.a6') }}</div> -->
        </div>
        <!-- <p class="textTitle">{{t('register.a7')}}</p> -->
        <div class="login-ipt">
          <div class="login-type"></div>
          <div class="login-from is-active-1">
            <van-form failed="onFailed" @submit="onSubmit">
              <van-field v-model="username" name="username" type="number" :placeholder="t('login.a1')"
                :rules="[{ required: true, message: t('register.a8') }, { pattern: /^\d{5,14}$/, message: t('register.a9') }]">
                <template #label>
                  <div @click="openPopupQh"> +{{ areaCode }} <van-icon name="arrow-down" /></div>
                </template>
              </van-field>
              <van-field v-model="password" name="password" :type="isShowPassword ? 'text' : 'password'"
                :placeholder="t('login.a2')"
                :rules="[{ required: true, message: t('register.a10') }, { pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/, message: t('register.a11') }]">
                <template #right-icon>
                  <span class="solts"><van-icon :name="isShowPassword ? 'eye-o' : 'closed-eye'"
                      @click="isShowPassword = !isShowPassword" /></span>
                </template>
              </van-field>
              <van-field v-model="confirmPassword" name="confirmPassword"
                :type="isShowConfirmPassword ? 'text' : 'password'" :placeholder="t('register.a1')"
                :rules="[{ required: true, message: t('register.a12') }, { pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/, message: t('register.a11') }, { validator: validateConfirm, message: t('register.a13') }]">
                <template #right-icon>
                  <span class="solts"><van-icon :name="isShowConfirmPassword ? 'eye-o' : 'closed-eye'"
                      @click="isShowConfirmPassword = !isShowConfirmPassword" /></span>
                </template>
              </van-field>
              <van-field v-model="invite" type="text" name="invite" :placeholder="t('register.a2')"
                :rules="[{ required: true, message: t('register.a14') }]" />
              <div class="btn-box">
                <van-button type="default" class="btn" :loading="loading" :loading-text="t('newRouter.a3')" native-type="submit">{{ t('register.a5') }} </van-button>
              </div>
              <div class="login-footer"><span>{{ t('register.a3') }}</span><span style="color:#2969FF;"
                  @click="router.push('/')">{{ t('register.a4') }}</span></div>
            </van-form>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script setup name="registerPage">
import { showSuccessToast, showFailToast } from 'vant';
import { register } from "@/api"
import { onMounted, ref } from "vue";
import { eventBus } from '@/utils/eventBus'
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n"
import demoVideo from "@/assets/video/test.mp4"

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const openPopup = () => { //语言
  eventBus.emit("toggleLangPopup", true)
}
const openPopupQh = () => { //区号
  eventBus.emit("toggleQhPopup", true)
}
eventBus.on("toggleAreaCode", (val) => { //区号切换
  areaCode.value = val
})

const isShowPassword = ref(false)
const isShowConfirmPassword = ref(false)

const areaCode = ref('54')
const username = ref('')
const password = ref('')
const confirmPassword = ref('')
const invite = ref(route.query.invite || '')

const validateConfirm = () => {
  return confirmPassword.value === password.value
}

const onFailed = (errorInfo) => {
  console.log('failed', errorInfo);
};
const loading = ref(false)
const onSubmit = (values) => {
  loading.value = true
  register({
    ...values,
    username: areaCode.value + values.username,
    confirmPassword: undefined
  }).then(res => {
    if (res.code == 200) {
      showSuccessToast(res.message)
      router.push('/')
    }
    loading.value = false
  }).catch(()=>{
    loading.value = false
  })
};
</script>
<style scoped lang="scss">
.login {
  min-height: 100vh;
  background: #010413;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;

  video {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .lang-icon {
    position: absolute;
    top: 10px;
    right: 15px;
    width: 24px;
    height: 24px;
    border-radius: 100%;
  }

  .login-container {
    width: 90%;
    margin: auto;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    background: rgba(255, 255, 255, 1);
    backdrop-filter: blur(25px);
    position: relative;
    border: none;
    z-index: 2;

    .title {
      font-size: 40px;
      font-family: Roboto;
      font-weight: 900;
      text-transform: uppercase;
      color: #fff;
      margin: auto;
    }

    .textTitle {
      color: #2969FF;
      text-align: center;
      font-family: "Microsoft YaHei UI";
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }

    .login-ipt {
      flex: 1;
      border-radius: 20px;
      overflow: hidden;

      .login-type {
        display: flex;
        align-items: center;
      }
    }

    .login-from {
      padding: 10px 15px 0;
    }

    .is-active-1 {
      border-top-left-radius: 0;
      border-top-right-radius: 20px;
    }

    .van-cell {
      border-radius: 8px;
      opacity: 1;
      background: #f5f8fa;
      box-sizing: border-box;
      color: #2969FF;
      margin-bottom: 15px;
    }

    :deep(.van-cell__title) {
      width: 80px;
      color: #000;
      border-right: 1px solid #a2a7aa;

      i {
        margin-left: 10px;
      }
    }

    .forgot-pwd {
      font-size: 12px;
      color: #2969FF;
      text-align: right;
      margin-top: 10px;
      margin-bottom: 50px;
      display: flex;
      align-content: center;
      justify-content: space-between;
      gap: 10px;

      .online-service {
        text-align: center;
        font-size: 12px;
        color: #2969FF;
      }
    }

    .btn-box {
      border-radius: 8px;
      overflow: hidden;
      margin-top: 30px;

      .btn {
        width: 100%;
        color: white;
        background: #2969FF;
        border-color: #2969FF;
      }
    }

    .login-footer {
      text-align: center;
      font-size: 12px;
      color: #a7afb7;
      margin-top: 15px;
    }
  }
}
</style>
